export const messages = {
  title: '力量训练',
  logs: '训练日志',
  plans: '训练计划',
  config: '字典配置',
  currentPlan: '当前计划',
  muscles: '肌群',
  exercises: '动作',
  machines: '器械',
  addLog: '记录训练',
  editLog: '编辑',
  deleteLog: '删除',
  confirmDelete: '确认删除这条训练记录？',
  save: '保存',
  cancel: '取消',
  empty: '还没有训练记录',
  sets: '组',
  reps: '次',
  weight: 'kg',
  duration: '时长',
  feeling: '感受',
  minutes: '分钟',
  totalVolume: '总量'
} as const
